import { FINANCIAL_STATUS } from '../types'
import { FinancialStatusRow } from './types'

export const getFinancialStatusTooltip = (row: FinancialStatusRow) => {
  if (
    row.status === FINANCIAL_STATUS.PARTIALLY_PAID ||
    row.status === FINANCIAL_STATUS.PAYMENT_FAILED
  ) {
    return row.transfers
      ?.filter((transfer) => transfer.status !== 'completed')
      .map((transfer) => transfer.destination?.issue_label)
      .join(', ')
  }
  return ''
}
